import * as React from 'react';
import { DetailsList, SelectionMode, IColumn, ISelection } from '@fluentui/react/lib/DetailsList';
import { SearchObjectService } from '../../services';
import { IEntity } from '../../types';
import { SearchBox } from '@fluentui/react/lib/SearchBox';
import { ICommandBarItemProps, ThemeProvider } from '@fluentui/react';
import { CrCommandBar } from '../cr/CrCommandBar';
import '../../styles/CustomFabric2.scss';
import styles from '../../styles/cr.module.scss';

export interface IFilteredMainListProps {
    className?: string;
    columns: IColumn[];
    items: any[];
    filterText?: string;
    onFilterChange: (value: string) => void;
    onItemTitleClick: (ID: number, title: string, filteredItems: any[]) => void;
    selection?: ISelection;
    onAdd: () => void;
    onDelete: () => void;
    onArchive: () => void;
    editDisabled: boolean;
    deleteDisabled: boolean;
    createPermission: boolean;
    deletePermission: boolean;
    archivedPermission: boolean;
    caseType: string;
    moveToLeavingPermission?: boolean;
    createExtensionPermission?: boolean;
    onMoveToLeaving: () => void;
    onCreateExtension: () => void;
}

export interface IFilteredMainListState {
    Columns: IColumn[];
    FilteredItems: any[];
}

export class FilteredMainList extends React.Component<IFilteredMainListProps, IFilteredMainListState> {
    constructor(props: IFilteredMainListProps) {
        super(props);

        props.columns.forEach((c) => { c.onColumnClick = this._onColumnClick; });
        this.state = {
            Columns: props.columns,
            FilteredItems: props.items,
        };
    }

    public render(): JSX.Element {
        const { props, state } = this;

        const commandBarItems: ICommandBarItemProps[] = [];
        const farCommandBarItems: ICommandBarItemProps[] = [];

        const addItem: ICommandBarItemProps = {
            key: 'NewCase',
            text: 'New Case',
            iconProps: { iconName: 'Add' },
            onClick: props.onAdd,
        };

        const deleteItem: ICommandBarItemProps = {
            key: 'Delete',
            text: 'Delete',
            iconProps: { iconName: 'Delete' },
            onClick: props.onDelete,
        };

        const moveToLeavingItem: ICommandBarItemProps = {
            key: 'MovetoLeaving',
            text: 'Move to Leaving',
            iconProps: { iconName: 'Leave' },
            onClick: props.onMoveToLeaving,
        };

        const createExtensionItem: ICommandBarItemProps = {
            key: 'CreateExtension',
            text: 'Create Extension',
            iconProps: { iconName: 'Leave' },
            onClick: props.onCreateExtension,
        };

        const archiveItem: ICommandBarItemProps = {
            key: 'Archive',
            text: 'Archive',
            iconProps: { iconName: 'Archive' },
            onClick: props.onArchive,
        };

        if (props.caseType === "BusinessCases" && props.createPermission && props.editDisabled && props.deleteDisabled)
            commandBarItems.push(addItem);

        if (props.caseType === "BusinessCases" && props.deletePermission && (props.editDisabled === false))
            commandBarItems.push(deleteItem);

        if (props.caseType === "Engaged" && props.moveToLeavingPermission && (props.editDisabled === false))
            commandBarItems.push(moveToLeavingItem);

        if (props.caseType === "Engaged" && props.createExtensionPermission && (props.editDisabled === false))
            commandBarItems.push(createExtensionItem);

        if ((props.caseType === "BusinessCases" || props.caseType === "Engaged") && props.archivedPermission && (props.editDisabled === false))
            commandBarItems.push(archiveItem);

        if (props.onFilterChange) {
            farCommandBarItems.push(
                {
                    key: 'filter',
                    text: 'List filter',
                    inActive: true,
                    onRender: function renderFilter() {
                        return (
                            <div className={styles.crCommandBarContainer}>
                                <SearchBox placeholder="Filter items" value={props.filterText?? ''} onChange={(_, v) => props.onFilterChange(v)} className={styles.listFilterBox} />
                            </div>
                        );
                    }
                }
            );
        }

        return (
            <ThemeProvider>
                <div>
                    <CrCommandBar className={props.className} items={commandBarItems} farItems={farCommandBarItems} />
                </div>
                <DetailsList
                    setKey={"state.FilteredItems"}
                    selectionMode={SelectionMode.single}
                    selection={props.selection}
                    columns={state.Columns}
                    items={state.FilteredItems}
                    onRenderItemColumn={this.renderItemColumn}
                />
            </ThemeProvider>
        );
    }

    public componentDidMount(): void {
        this.setState({ FilteredItems: SearchObjectService.filterEntities(this.props.items, this.props.filterText) });
    }

    public componentDidUpdate(prevProps: IFilteredMainListProps): void {
        if (prevProps.columns !== this.props.columns) {
            this.props.columns.forEach((c) => { c.onColumnClick = this._onColumnClick; });
            this.setState({ Columns: this.props.columns, FilteredItems: SearchObjectService.filterEntities(this.props.items, this.props.filterText) });
        }
        else if (prevProps.items !== this.props.items || prevProps.filterText !== this.props.filterText) {

            this.setState({ FilteredItems: SearchObjectService.filterEntities(this.props.items, this.props.filterText) });
        }
    }

    private renderItemColumn = (item: IEntity, index: number, column: IColumn) => {
        let fieldContent = item[column.fieldName as keyof IEntity] as string;

        if (column.key === "CaseRef") {
            const id: number = item["ID"];
            return (
                <span><a className="titleLnk" onClick={(ev) => this.props.onItemTitleClick(id, fieldContent, this.state.FilteredItems)} > {fieldContent}</a> </span>
            );
        }
        else if (column.key === "Title1") {
            const title2: string = item["Title2"];
            return (

                <span>{fieldContent}<br />{title2}</span>
            );
        }
        else if (column.key === "StageActions1") {
            const stageActions2: string = item["StageActions2"];
            return (
                <span>{fieldContent}
                    {stageActions2.length > 0 &&
                        <React.Fragment>
                            <br />
                            <span>{stageActions2}</span>
                        </React.Fragment>
                    }
                </span>
            );
        }
        else {
            return <span>{fieldContent}</span>;
        }
    }

    private _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { Columns, FilteredItems } = this.state;
        let newItems: any[] = FilteredItems.slice();
        const newColumns: IColumn[] = Columns.slice();
        const currColumn: IColumn = newColumns.filter((currCol: IColumn, idx: number) => {
            return column.key === currCol.key;
        })[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        newItems = this._sortItems(newItems, currColumn.fieldName || '', currColumn.isSortedDescending);
        this.setState({
            Columns: newColumns,
            FilteredItems: newItems
        });
    }

    private _sortItems = (items: any[], sortBy: string, descending = false): any[] => {
        return items.sort((a, b) => {
            if (!a.hasOwnProperty(sortBy) || !b.hasOwnProperty(sortBy)) {
                // property doesn't exist on either object
                return 0;
            }

            const varA = (typeof a[sortBy] === 'string') ? a[sortBy].toLowerCase() : a[sortBy];
            const varB = (typeof b[sortBy] === 'string') ? b[sortBy].toLowerCase() : b[sortBy];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return ((descending) ? (comparison * -1) : comparison);
        });
    }
}
